const Loader = () => {
  return (
    <div className="loader">
      <div className="lds-ripple">
        <div></div>
        <div></div>
      </div>
      En chargement...
    </div>
  );
};

export default Loader;
